module.exports = __webpack_public_path__ + "2f4a344640422e8d42f36b5c83fcb7b8.png";